module.exports = __webpack_public_path__ + "img/jhsys3.b4d83c02.png";